import React, { memo, useState, useRef } from "react";
import { useSpring, a, useChain, config } from "react-spring";
import { useMeasure, usePrevious } from "./helpers";
import * as styles from "../../styles/menu/tree.module.css";
import * as Icons from "./Icons";

const Tree = memo(
  ({
    //Check if a tree node has any child nodes
    children,
    //Name of node
    name,
    //Numbr of child nodes
    number,
    //Color to fill
    fill,
    //Fucntion to execute on click on node name
    nameClick,
    //Fucntion to execute on click on icon
    iconClick,
    iconStyle,
    className,
    attachHref = true,
    defaultOpen = false,
  }) => {
    const TreeRef = useRef();
    const [isOpen, setOpen] = useState(defaultOpen);
    const previous = usePrevious(isOpen);
    const [bind, { height: viewHeight }] = useMeasure();
    const treeAnimationRef = useRef();
    const linkAnimationRef = useRef();
    const { height, opacity, transform } = useSpring({
      from: { height: 0, opacity: 0, transform: "translate3d(20px,0,0)" },
      to: {
        height: isOpen ? viewHeight : 0,
        opacity: isOpen ? 1 : 0,
        transform: `translate3d(${isOpen ? 0 : 20}px,0,0)`,
      },
      ref: treeAnimationRef,
      config: isOpen ? config.wobbly : config.default,
    });
    const { pointerEvents } = useSpring({
      from: { pointerEvents: `none` },
      to: { pointerEvents: isOpen ? `all` : `none` },
      ref: linkAnimationRef,
    });
    useChain(
      isOpen
        ? [linkAnimationRef, treeAnimationRef]
        : [treeAnimationRef, linkAnimationRef]
    );
    const Icon =
      Icons[`${children ? (isOpen ? "Minus" : "Plus") : "Close"}Square`];
    return (
      <div className={styles.TreeContainer}>
        <Icon
          className={styles.icon}
          style={{ opacity: children ? 1 : 0.3, fill: "#d19851", ...iconStyle }}
          onClick={() => {
            iconClick && iconClick();
            setOpen(!isOpen);
          }}
        />
        <p
          onClick={() => {
            nameClick && nameClick();
          }}
          className={`${className} ${styles.courseName} `}
        >
          {attachHref ? (
            <a.a
              style={{ color: fill || "black" }}
              href={`#${name.replace(/\s/g, "")}`}
            >
              {name}
              <span className={styles.number}>{number && `(${number})`}</span>
            </a.a>
          ) : (
            <span style={{ color: fill || "black" }}>{name}</span>
          )}
        </p>
        <a.div
          className={styles.treeContentContainer}
          style={{
            pointerEvents: pointerEvents,
            borderColor: fill,
            opacity,
            height: isOpen && previous === isOpen ? "auto" : height,
          }}
        >
          <a.div
            ref={TreeRef}
            style={{
              transform: transform,
            }}
            {...bind}
            children={children}
          />
        </a.div>
      </div>
    );
  }
);

export default Tree;
